"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _BundlePage = require("../BundlePage");

var _ShoppingCartItem = _interopRequireDefault(require("./ShoppingCartItem"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _FormattedNumber = _interopRequireDefault(require("I18n/components/FormattedNumber"));

var _MerchandiseSelectors = require("../../../selectors/MerchandiseSelectors");

function ContactsItem() {
  var _useContext = (0, _react.useContext)(_BundlePage.BundleContext),
      state = _useContext.state,
      setState = _useContext.setState;

  var marketingPlanSelected = state.marketingPlanSelected,
      marketingUnits = state.marketingUnits;
  var merchandiseMap = (0, _reactRedux.useSelector)(_MerchandiseSelectors.merchandiseSelector);
  var included = merchandiseMap[marketingPlanSelected].includedAdditionalUnits;
  return _react.default.createElement(_ShoppingCartItem.default, {
    merchandiseId: marketingPlanSelected,
    additionalUnitQuantity: marketingUnits,
    unit: _react.default.createElement(_FormattedReactMessage.default, {
      message: "bundles.shoppingCart.additionalContacts",
      "data-selenium-class": "shopping-cart-item-unit",
      options: {
        contacts: _react.default.createElement(_FormattedNumber.default, {
          value: included + marketingUnits
        })
      }
    }),
    onRemove: function onRemove() {
      return setState({
        marketingPlanSelected: null,
        marketingUnits: 0
      });
    }
  });
}

var _default = ContactsItem;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/shopping-cart/ContactsItem.js
// module id = 707
// module chunks = 5 6